import type { AcceptInviteCommand, AcceptInviteResult, InvitePreview } from "@/domain/model/Invitation";
import type { InvitationService } from "@/domain/port/InvitationService";
import type { HttpClient } from "@/infrastructure/HttpClient";
import type { AcceptInviteResultDto, InvitePreviewDto, InvitePreviewRequestDto } from "./dto/InvitationDto";
import { mapAcceptInviteCommandToDto, mapAcceptInviteResultDtoToModel, mapInvitePreviewDtoToModel } from "./mappers/InvitationMappers";

export class InvitationServiceImpl implements InvitationService {
  constructor(private readonly http: HttpClient) {}

  async previewInvitation(token: string, signal?: AbortSignal): Promise<InvitePreview> {

    const body: InvitePreviewRequestDto = { token };
    const dto = await this.http.request<InvitePreviewDto>(
      "/api/invitations/preview",
      {
        method: "POST",
        body: JSON.stringify(body),
        signal,
      }
    );

    return mapInvitePreviewDtoToModel(dto);
  }

  async acceptInvitation(
    cmd: AcceptInviteCommand,
    signal?: AbortSignal,
  ): Promise<AcceptInviteResult> {
    const body = mapAcceptInviteCommandToDto(cmd);
    const dto = await this.http.request<AcceptInviteResultDto>(
      "/api/invitations/accept",
      {
        method: "POST",
        body: JSON.stringify(body),
        signal
      }
    );
    return mapAcceptInviteResultDtoToModel(dto);
  }
}
